/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { canUseDom } from './canUseDom.js';
import '../_chunks/dep-c9dcffa1.js';
import '../_chunks/dep-9fe8d051.js';

var supportsPassive = false;
if (canUseDom) {
  try {
    var opts = {};
    Object.defineProperty(opts, "passive", {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test-passive", null, opts);
  } catch (e) {}
}

export { supportsPassive };
//# sourceMappingURL=supportsPassive.js.map
